import React from 'react';

import { SimpleButton } from './simpleButton';

export const SolidButton = ({
  onClick,
  label,
  style,
  disabled = false,
}: {
  onClick?: () => void;
  label: React.ReactNode;
  style?: React.CSSProperties;
  disabled?: boolean;
}) => {
  return (
    <SimpleButton
      onClick={onClick}
      style={{
        background: 'rgb(81, 89, 102)',
        color: '#FFFFFF',
        ...style,
      }}
      label={label}
      disabled={disabled}
    />
  );
};
